import { daaluuKind, type DaaluuTile as Tile } from '@big2/shared';
import { DAALUU_FACE_DOTS } from './daaluuFaces.js';

export function DaaluuTile({ tile, selected = false, onSelect, disabled = false, dead = false, deadLabel = 'Dead' }: {
  tile: Tile; selected?: boolean; onSelect?: () => void; disabled?: boolean; dead?: boolean; deadLabel?: string;
}) {
  const kind = daaluuKind(tile);
  const face = <svg className="daaluu-pip-face" viewBox="0 0 40 86" aria-hidden="true" focusable="false">
    {DAALUU_FACE_DOTS[kind.id].map(({ x, y, red }, index) => <circle key={index}
      className={`has-pip${red ? ' red-pip' : ''}`} cx={x} cy={y} r="5.8" />)}
  </svg>;
  const label = `${kind.name}, ${kind.pips[0]}–${kind.pips[1]}, ${kind.color}, ${kind.rank}${dead ? ` · ${deadLabel}` : ''}`;
  const className = `daaluu-face-tile${selected ? ' selected' : ''}${dead ? ' is-dead' : ''}`;
  return onSelect ? <button className={className} aria-label={label} aria-pressed={selected} onClick={onSelect} disabled={disabled}>{face}</button>
    : <span className={className} role="img" aria-label={label}>{face}</span>;
}
